module.exports = __webpack_public_path__ + "img/icon-bg(1).5900b484.svg";